// extracted by mini-css-extract-plugin
export var footer = "_pq-5";
export var fulfillmentInput = "_pq-0";
export var shipDateInput = "_pq-1";
export var shipmentModal = "_pq-2";
export var shipmentModalContent = "_pq-3";
export var tableContainer = "_pq-4";